import {SuccessSVG, SuccessStatusSVG} from "assets";
import React from "react";
import {ColumnsEdit} from "types/models/column-table-edit";
import "./Voucher.scss";
import {FIELD_TYPE} from "types/enums";
import {DataFormField} from "types/models/input-field-type";
import {formatToCurrencyType} from "helper/common";
import TTTTTypeColumn from "components/common/ColumnColors/KCBTypeColumn/TTTTTypeColumn";
import dayjs from "dayjs";
const {INPUT, SELECT, DATE, CURRENCY} = FIELD_TYPE;

const columnsPrepay: ColumnsEdit = [
  // {
  //   title: "STT",
  //   dataIndex: "stt",
  //   key: "stt",
  //   render: (text, record, index) => index + 1,
  //   width: "6%",
  //   align: "center",
  // },
  {
    title: "Tên chương trình",
    dataIndex: "tenChuongTrinh",
    show: true,
    align: "left",
   // width:"20%"
  },
  {
    title: "Tên gói dịch vụ",
    dataIndex: "tenGoiDichVu",
    show: true,
    align: "left",
    //width: "20%",
    render: (text) => <div dangerouslySetInnerHTML={{ __html: text }} />
},
{
    title: "Tên dịch vụ",
    dataIndex: "tenDichVu",
    show: true,
    align: "left",
  //  width: "20%",
    render: (text) => <div dangerouslySetInnerHTML={{ __html: text }} />
},
  {
    title: "Điều kiện áp dụng",
    dataIndex: "dieuKien",
    show: true,
    align: "right",
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  {
    title: "Số lần áp dụng",
    dataIndex: "soLanApDung",
    show: true,
    align: "right",
  },
  {
    title: "Giảm giá",
    dataIndex: "giamGia",
    show: true,
    align: "right",
    render(value, record, index) {
      // Format the giamGia value to currency type
      const formattedValue = formatToCurrencyType(value);
  
      // Determine the unit to append based on loaiGiamGia
      const unit = record.loaiGiamGia === 0 ? 'đ' : (record.loaiGiamGia === 1 ? '%' : '');
  
      return <>{`${formattedValue} ${unit}`}</>;
    },
  },
  {
    title: "Giảm giá tối đa",
    dataIndex: "giamGiaToiDa",
    show: true,
    align: "right",
    render(value, record, index) {
      return <>{formatToCurrencyType(value)}</>;
    },
  },
  // {
  //   title: "Áp dụng từ",
  //   dataIndex: "ngayBatDau",
  //   show: true,
  //   align: "center",
  //   render: (v, r, idx) => v !== null ? dayjs(v).format("DD/MM/YYYY") : null ,
  // },
  // {
  //   title: "Áp dụng đến",
  //   dataIndex: "ngayKetThuc",
  //   show: true,
  //   align: "center",
  //   render: (v, r, idx) => v !== null ? dayjs(v).format("DD/MM/YYYY") : null ,
  // },
  // {
  //   title: "Mô tả",
  //   dataIndex: "moTa",
  //   show: true,
  //   align: "left",
  //  // width: "8%",
  // },
  // {
  //   title: "Trạng thái",
  //   dataIndex: "trangThai",
  //   show: true,
  //   align: "center",
  //   render: (v, r, idx) => 
  //     {
  //       const valueMap = {
  //         "0": "Chưa kích hoạt",
  //         "1": "Hiệu lực",
  //         "2": "Hết hiệu lực",
  //       };
  //       const backgroundColors = {
  //         "Chưa kích hoạt": "#3380FF",
  //         "Hiệu lực": "#00b335",
  //         "Hết hiệu lực": "#eb0510",
  //       };
  //       const displayValue = valueMap[v] || v;
  //       const backgroundColor = backgroundColors[displayValue] || "";
  //         if(v === 0)
  //           {
  //             return (
  //               <div className="color-column" style={{ backgroundColor }}>
  //                 {displayValue}
  //               </div>
  //             );
  //           }
  //         else if(v === 1)
  //           {
  //             return (
  //               <div className="color-column" style={{ backgroundColor }}>
  //                 {displayValue}
  //               </div>
  //             );
  //           }
  //         else if(v === 2)
  //           {
  //             return (
  //               <div className="color-column" style={{ backgroundColor }}>
  //                 {displayValue}
  //               </div>
  //             );
  //           }
  //     },
  //   width: "8%",
  // },
  {
    title: "Thao tác",
    dataIndex: "action",
    key: "action",
    // editable: true,
    // width: '13%',
    align: "center",
  },
];

export {columnsPrepay};
